import React from 'react';
import StyleControlsPanel from './StyleControlsPanel';
import StylesheetPanel from './StylesheetPanel';
import TemplatesPanel from './TemplatesPanel';

const tabs = [
    { id: 'controls', label: 'Controls', icon: 'fa-sliders' },
    { id: 'css', label: 'CSS', icon: 'fa-code' },
    { id: 'templates', label: 'Templates', icon: 'fa-layer-group' }
];

export default function StylingPanel({
    activeTab,
    setActiveTab,
    manualStyles,
    onStyleChange,
    properties,
    setProperties,
    setShowTemplatePicker,
    setPages,
    setActivePageIndex,
    onEmbedChange
}) {
    return (
        <aside style={{
            width: '340px',
            minWidth: '340px',
            background: 'var(--bg-secondary)',
            border: '1px solid var(--border)',
            borderRadius: 'var(--radius)',
            display: 'flex',
            flexDirection: 'column',
            maxHeight: '80vh',
            overflow: 'hidden'
        }}>
            <div style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
                borderBottom: '1px solid var(--border)'
            }}>
                {tabs.map(tab => (
                    <button
                        key={tab.id}
                        type="button"
                        className={`item-highlight segment-tab${activeTab === tab.id ? ' is-selected' : ''}`}
                        onClick={() => setActiveTab(tab.id)}
                    >
                        <i className={`fa-solid ${tab.icon}`}></i>
                        {tab.label}
                    </button>
                ))}
            </div>

            <div style={{ padding: '1rem', overflowY: 'auto', flex: 1 }}>
                {activeTab === 'controls' && (
                    <StyleControlsPanel
                        manualStyles={manualStyles}
                        onStyleChange={onStyleChange}
                        embed={properties.embed}
                        onEmbedChange={onEmbedChange}
                    />
                )}

                {activeTab === 'css' && (
                    <StylesheetPanel
                        customCss={properties.customCss}
                        setCustomCss={(value) => setProperties(prev => ({ ...prev, customCss: value }))}
                    />
                )}

                {activeTab === 'templates' && (
                    <TemplatesPanel
                        setShowTemplatePicker={setShowTemplatePicker}
                        setProperties={setProperties}
                        setPages={setPages}
                        setActivePageIndex={setActivePageIndex}
                    />
                )}
            </div>
        </aside>
    );
}
